import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  min-height: 100vh;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  background: #0a1628;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
`;
